export default __webpack_public_path__ + "static/media/password.3db72899.png";